<template>
  <div>
    <b-modal v-model="inputVal.show"
            centered
            hide-header
            hide-footer
            @hidden="handleModalHidden"
            @hide="$emit('hide')"
    >
      <div class="success-modal__body d-flex flex-column align-items-center">
        <span class="success-modal__msg mb-4">{{ inputVal.msg }}</span>
        <b-button v-if="inputVal.back"
                  variant="primary"
                  size="large"
                  @click="$router.replace(inputVal.back.location)"
        >
          {{ inputVal.back.text || '返回' }}
        </b-button>
        <b-button v-else
                  variant="primary"
                  @click="inputVal.show = false"
        >
          確定
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue';
import vModelMixin from '@/mixins/v-model';

export default {
  mixins: [vModelMixin],
  components: {
    BButton,
  },
  methods: {
    handleModalHidden() {
      if (['REMOVE', 'SUBMIT_SUCCESS'].includes(this.inputVal.action) && this.inputVal.back) {
        this.$router.replace(this.inputVal.back.location);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.success-modal {
  &__body {
    padding: 12px;
  }

  &__msg {
    font-size: 1.25rem;
    font-weight: 500;
    color: #636d77;
  }
}
</style>
